module.exports = __webpack_public_path__ + "static/media/semConvidados.210e94fa.PNG";